export default "__VITE_ASSET__9b319cb1__"